import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';

import { DbKey } from '../../../../adl-gen/common/db';
import { AppUser } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { AppUserListEntry } from '../../../../adl-gen/totalinteraction/futurefit/frontend';
import { UserData } from '../../../../adl-gen/totalinteraction/futurefit/requests';
import { Loader } from '../../../../loader/loader';
import { AppUserStore } from '../../../stores';
import { FormMode } from '../../common/form';
import { AdminPageLayoutFn } from '../../common/page-layout/admin-page-layout';
import { AppUserForm } from '../../components/forms/appuser-form/appuser-form';
import { AppUserDetailsView } from '../../components/detail-views/appuser-details-view';

interface AppUserDetailScreenProps {
  pageLayout: AdminPageLayoutFn;

  mode?: FormMode;

  store: AppUserStore;

  onCancel?(): Promise<void>;
  onUpdate?(appUserId: DbKey<AppUser>): Promise<void>;

  // processUpload(data: ClientUsersUploadData, clientId: DbKey<AppClient>): Promise<void>
  // report?: UploadReportRecord[]
}

@observer
export class AppUserDetailScreen extends React.Component<AppUserDetailScreenProps> {
  /// If modals used...
  @observable.ref isOpen = false;
  // @observable.ref selectedTabKey: React.ReactText = 0
  // @observable uploadData?: ClientUsersUploadData

  @action toggleOpen(): void {
    this.isOpen = !this.isOpen;
  }

  renderUserDetails = observer((user: AppUserListEntry) => {
    const { onUpdate, store } = this.props;

    const data = store.loadingData;
    const loadingUsers = store.loadingList;
    const managerEntry =
      user.managerId && loadingUsers.kind === 'value'
        ? loadingUsers.value.items.find(u => u.id === user.managerId)
        : undefined;
    const managerFullname = managerEntry ? managerEntry.fullname : undefined;

    /// TODO: This is not great - assuming there's only one item in an array
    /// rather than just selecting that one item
    if (data.kind === 'value' && onUpdate) {
      return (
        <AppUserDetailsView
          user={user}
          userData={data.value}
          onUpdate={onUpdate}
          role={store.isSuperUser ? 'super' : 'client-admin'}
          managerFullname={managerFullname}
        />
      );
    } else {
      return null;
    }
  });

  renderCreateUserForm = observer((userData: UserData) => {
    const {
      // mode,
      onCancel,
      store
    } = this.props;

    if (onCancel) {
      return (
        <AppUserForm
          userData={userData}
          store={store}
          selectMode="reload"
          // mode={mode}

          onCancel={onCancel}
          // isOpen={true}
        />
      );
    } else {
      return null;
    }
  });

  renderUpdateUserForm = observer((user: AppUserListEntry) => {
    const { onCancel, store } = this.props;

    const userData = store.loadingData.kind === 'value' ? store.loadingData.value : undefined;
    if (onCancel && userData) {
      return <AppUserForm user={user} userData={userData} store={store} selectMode="reload" onCancel={onCancel} />;
    } else {
      return null;
    }
  });

  UserDetailsLoader = () => {
    const { store, mode } = this.props;
    const user = store.selectedUser;
    if (user) {
      if (mode === 'update' || mode === 'delete') {
        return (
          <Loader
            state={user}
            // state={store.loadingData}
            LoadedComponent={this.renderUpdateUserForm}
          />
        );
      } else {
        /// View
        return <Loader state={user} LoadedComponent={this.renderUserDetails} />;
      }
    } else {
      /// Create - mode doesn't matter
      return <Loader state={store.loadingData} LoadedComponent={this.renderCreateUserForm} />;
    }
  };

  render() {
    return (
      <this.props.pageLayout title={'Administration - User'}>
        <this.UserDetailsLoader />
      </this.props.pageLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/screens/appuser-detail-screen/appuser-detail-screen.tsx